import { useContext } from "react";
import UserContext from "../../../state/UserContext";
import { JourneyFormGroupDto } from "../../../types/dtos/journeys";
import DashboardRightBarDto from "../../../types/dtos/dashboards/right-bar/DashboardRightBarDto";
import ModifyTaskResponseDto from "../../../types/dtos/tasks/ModifyTaskResponseDto";
import DashboardCatchUps from "./catch-ups/DashboardCatchUps";
import DashboardManagerTeamWidget from "./manager-team/DashboardManagerTeamWidget";
import RightBarTasksList from "./RightBarTasksList";

interface DashboardRightBarProps {
  details: DashboardRightBarDto;
  formDetails: JourneyFormGroupDto | undefined | null;
  hasJourneyBeenSubmitted: boolean;
  onManagerTodosChanged: () => void;
  modifyStandardTaskFromDashboard(
    task: any,
    onSuccess: (taskData: ModifyTaskResponseDto<number>) => void,
  ): void;
  onLoadStandardTaskToEdit(
    taskId: number,
    taskType: string,
    successCallback: (responseData: any) => void,
  ): void;
}

function DashboardRightBar({
  details,
  formDetails,
  hasJourneyBeenSubmitted,
  onManagerTodosChanged,
  modifyStandardTaskFromDashboard,
  onLoadStandardTaskToEdit,
}: DashboardRightBarProps) {
  const userContext = useContext(UserContext);
  const showManagerTeamWidget =
    (userContext.user.isManager || userContext.user.isJourneyManager) &&
    details.managerTeamTodos != null;

  return (
    <div
      id="scrollable-dashboard-right-bar"
      className="snap-y overflow-y-auto overflow-x-hidden grow ml-1"
    >
      {showManagerTeamWidget && (
        <DashboardManagerTeamWidget
          section={details.managerTeamTodos!}
          onTodosChanged={onManagerTodosChanged}
        />
      )}
      <RightBarTasksList
        toDoListTaskTypes={details.toDoListTaskTypes}
        standardListItems={details.standardListItems}
        advancedListItems={details.advancedListItems}
        formDetails={formDetails}
        hasJourneyBeenSubmitted={hasJourneyBeenSubmitted}
        modifyStandardTaskFromDashboard={modifyStandardTaskFromDashboard}
        onLoadStandardTaskToEdit={onLoadStandardTaskToEdit}
      />
      <div id="catch-up-list" className="bg-white rounded-lg p-4 mt-4 mb-20">
        <DashboardCatchUps initialCatchUps={details.catchUps} />
      </div>
    </div>
  );
}

export default DashboardRightBar;
